(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nightmare-product-video"] && !Shopify.designMode) return;
  try {
    class NightmareProductVideo extends HTMLElement {
    #controller;
    #intersectionObserver;
    #dialogObserver;
    #video;
    #gallery;
    #motion;
    #intersecting = false;
    #pending = false;
    #automaticPauseEvents = 0;
    #startedAutomatically = false;
    #autoplayBlocked = false;
    #generation = 0;

    connectedCallback() {
      this.#video = this.querySelector('video');
      if (!this.#video) return;
      this.#controller = new AbortController();
      this.#gallery = this.closest('media-gallery');
      this.#motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.#intersecting = false;
      this.#pending = false;
      this.#automaticPauseEvents = 0;
      this.#startedAutomatically = false;
      this.#autoplayBlocked = false;
      this.#generation += 1;
      const { signal } = this.#controller;
      this.#video.autoplay = false;
      this.#video.muted = true;
      this.#video.defaultMuted = true;
      this.#video.playsInline = true;

      this.addEventListener('click', (event) => event.stopPropagation(), { signal });
      this.#video.addEventListener('play', () => {
        if (!this.#pending) {
          this.#startedAutomatically = false;
          this.#setManualPause(false);
        }
        if (!this.#visible()) this.#pause();
      }, { signal });
      this.#video.addEventListener('pause', () => {
        if (this.#automaticPauseEvents > 0) {
          this.#automaticPauseEvents -= 1;
        } else if (this.#visible()) {
          this.#setManualPause(true);
        }
      }, { signal });
      this.#gallery?.addEventListener('play', (event) => {
        if (event.target !== this.#video) this.#pause();
      }, { signal, capture: true });
      document.addEventListener('visibilitychange', this.#sync, { signal });
      window.addEventListener('resize', this.#sync, { signal, passive: true });
      this.#motion.addEventListener('change', this.#sync, { signal });

      if ('IntersectionObserver' in window) {
        this.#intersectionObserver = new IntersectionObserver((entries) => {
          const entry = entries[entries.length - 1];
          this.#intersecting = entry.isIntersecting && entry.intersectionRatio >= 0.05;
          this.#sync();
        }, { threshold: [0, 0.05] });
        this.#intersectionObserver.observe(this);
      } else {
        this.#intersecting = true;
        window.addEventListener('scroll', this.#sync, { signal, passive: true });
      }

      if (this.#gallery) {
        this.#dialogObserver = new MutationObserver(this.#sync);
        this.#dialogObserver.observe(this.#gallery, {
          subtree: true,
          attributes: true,
          attributeFilter: ['open'],
        });
      }
      this.#sync();
    }

    disconnectedCallback() {
      this.#generation += 1;
      this.#controller?.abort();
      this.#intersectionObserver?.disconnect();
      this.#dialogObserver?.disconnect();
      this.#video?.pause();
    }

    #setManualPause(paused) {
      const holder = this.#gallery || this;
      holder.dataset.nightmareVideoManualPaused = String(paused);
    }

    #manuallyPaused() {
      return (this.#gallery || this).dataset.nightmareVideoManualPaused === 'true';
    }

    #visible() {
      if (!this.isConnected || !this.#intersecting || document.hidden) return false;
      if (this.#gallery?.querySelector('dialog[open]')) return false;
      if (this.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      const rect = this.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || this.getClientRects().length === 0) return false;
      const width = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
      const height = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      if (width <= 0 || height <= 0 || width * height / (rect.width * rect.height) < 0.05) return false;
      const style = getComputedStyle(this);
      return style.visibility !== 'hidden' && style.visibility !== 'collapse' && style.opacity !== '0';
    }

    #anotherVideoPlaying() {
      return Array.from(this.#gallery?.querySelectorAll('video') || []).some(
        (video) => video !== this.#video && !video.paused && !video.ended,
      );
    }

    #pause() {
      if (!this.#video || this.#video.paused) return;
      this.#automaticPauseEvents += 1;
      this.#video.pause();
    }

    #sync = () => {
      if (!this.#video || !this.isConnected) return;
      if (!this.#visible() || (this.#motion.matches && this.#startedAutomatically)) {
        this.#pause();
        return;
      }
      if (
        this.#video.paused && !this.#motion.matches && !this.#manuallyPaused() &&
        !this.#pending && !this.#autoplayBlocked && !this.#anotherVideoPlaying()
      ) {
        void this.#play();
      }
    };

    async #play() {
      const generation = this.#generation;
      const video = this.#video;
      this.#pending = true;
      this.#startedAutomatically = true;
      video.muted = true;
      try {
        await video.play();
        if (generation !== this.#generation) return;
        if (
          !this.#visible() ||
          this.#motion.matches || this.#manuallyPaused() || this.#anotherVideoPlaying()
        ) {
          this.#pause();
        }
      } catch (error) {
        if (generation === this.#generation && error.name !== 'AbortError') {
          this.#autoplayBlocked = true;
        }
      } finally {
        if (generation === this.#generation) this.#pending = false;
      }
    }
  }

  if (!customElements.get('nightmare-product-video')) {
    customElements.define('nightmare-product-video', NightmareProductVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
